import { useState, useEffect, useCallback } from 'react';
import * as api from '../features/chatrequests';
import { getDomainCfg } from '../core/state';

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const authenticate = useCallback(async () => {
    try {
      const session = await api.authenticateUser();
      if (session.error) {
        console.warn('Authentication error:', session.message);
        setIsAuthenticated(false);
        return false;
      }
      console.log('Auth: user-session', session);
      await api.setNickname(getDomainCfg().chatSettings?.userName);
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      console.warn('Authentication error:', error);
      setIsAuthenticated(false);
      return false;
    }
  }, []);

  useEffect(() => {
    authenticate();
  }, [authenticate]);

  return { isAuthenticated, authenticate };
}